import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { clsx } from 'clsx';

const badgeStyles = cva('inline-flex items-center font-medium rounded-md uppercase tracking-wide', {
  variants: {
    tone: {
      neutral: 'bg-subtle text-ink-primary',
      accent: 'bg-accent text-accent-contrast',
      warning: 'bg-warning text-warning-contrast',
      danger: 'bg-danger text-danger-contrast',
      info: 'bg-info text-info-contrast',
    },
    size: {
      sm: 'text-[10px] px-1.5 py-0.5',
      md: 'text-xs px-2 py-1',
    },
  },
  defaultVariants: {
    tone: 'neutral',
    size: 'sm',
  },
});

interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeStyles> {}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { tone, size, className, ...rest },
  ref
) {
  return <span ref={ref} className={clsx(badgeStyles({ tone, size }), className)} {...rest} />;
});
